import PostCreator from './post-creator'

export type { PostCreatorProps } from './post-creator'

export default PostCreator
